
export class ScrollService {

    scrollTop() {
        var ele = document.getElementById("mainwrapper");
        ele.scrollIntoView();
        ele.scrollTop = 0;
    }

}





// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/scroll.service.ts